<!-- 听录音跟读 -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" label-width="100px">
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item label="">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>
      <el-form-item :label="'学习内容' + (index + 1)" prop="wordName">
        <el-input v-model="item.wordName" disabled style="width: 350px;" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        dataList: [

        ]
      }
    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      for (const item of this.gameList) {
        this.interferenceForm.dataList.push({ state: item.state, studyId: item.studyId, wordName: item.wordName, meansType: item.meansType })
      }
    }
  },
  created () {

  },
  methods: {
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },
    saveGameOptions () {
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: this.currentQuizType,

        items: this.interferenceForm.dataList
      }
      saveConfData(params).then(res => {
        this.$message.success('操作成功')
        this.$emit('finishSave')
      })
    }
  }
}
</script>

<style lang='scss'>

</style>
